import script from "./cpt-threejs-dom.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-threejs-dom.vue?vue&type=script&setup=true&lang=js"

import "./cpt-threejs-dom.vue?vue&type=style&index=0&id=13b04216&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b04216"]])

export default __exports__